import { LoadingWrapper, Logo } from './Spinner.styles';

export default function LoadingScreen() {
  return (
    <LoadingWrapper>
      <Logo src='/LogoBlack.png' alt='App Logo' />
    </LoadingWrapper>
  );
}
